export const useApi = () => {
  const apiPrefix = 'jvn/show'
  const apiPrefixForCustomer = 'jvn'

  const authApi = {
    LOGIN: apiPrefix + '/user/login',
    LOGOUT: apiPrefix + '/user/logout',
    USER: apiPrefix + '/user',
    REFRESH: apiPrefix + '/user/refreshToken',
    VERIFICATION: apiPrefix + '/user/checkUserVerification',
    RESETPASSWORD: apiPrefix + '/user/resetPassword',
    SEND_RESET_PASSWORD_LINK: apiPrefix + '/user/sendPasswordResetLink'
  }
  const authApiForCustomer = {
    LOGIN: apiPrefixForCustomer + '/user/login',
    LOGOUT: apiPrefixForCustomer + '/user/logout',
    USER: apiPrefixForCustomer + '/user',
    REFRESH: apiPrefixForCustomer + '/user/refreshToken',
    VERIFICATION: apiPrefixForCustomer + '/user/checkUserVerification',
    RESETPASSWORD: apiPrefixForCustomer + '/user/resetPassword',
    SEND_RESET_PASSWORD_LINK: apiPrefixForCustomer + '/user/sendPasswordResetLink'
  }
  const customerApi = {
    CUSTOMER: apiPrefix + '/customer',
    UPDATE_PRIMARY_EMAIL: apiPrefix + '/customer/updatePrimaryEmail'
  }
  const catalogApi = {
    CATALOG_STYLE: apiPrefix + '/catalog/style/%s',
    CATALOG_CATEGORY: apiPrefix + '/catalog/category/%s',
    CATALOG_SHOWCATEGORY: apiPrefix + '/catalog/showCategory/%s',
    CATALOG_CATEGORYLIST: apiPrefix + '/catalog/categoryList',
    CATALOG_CATALOGLIST: apiPrefix + '/catalog/catalogList'
  }
  const productApi = {
    PRODUCT_LIST: apiPrefix + '/product/list',
    PRODUCT_DETAIL: apiPrefix + '/product/detail'
  }
  const cartApi = {
    CART: apiPrefix + '/cart',
    CART_ADD: apiPrefix + '/cart/add',
    CART_COUNT: apiPrefix + '/cart/count'
  }
  const checkoutApi = {
    CHECKOUT: apiPrefix + '/checkout',
    CHECKOUT_ME: apiPrefix + '/checkout/me'
  }
  const salesOrderApi = {
    SALESORDER_LIST: apiPrefix + '/salesorder/list',
    SALESORDER_DETAIL: apiPrefix + '/salesorder/detail/%s',
    SALESORDER_PRINT: apiPrefix + '/salesorder/print/%s',
    SALESORDER_EMAIL: apiPrefix + '/salesorder/email/%s'
  }
  return {
    authApi,
    authApiForCustomer,
    customerApi,
    catalogApi,
    productApi,
    cartApi,
    checkoutApi,
    salesOrderApi
  }
}
